






















































































































































































































































































































































































































import BaseDialog from '@/components/BaseDialog.vue';
import VExtendedDataPicker from '@/components/VExtendedDataPicker.vue';
import AudioPlayerBtn from '@/components/media/AudioPlayerBtn.vue';
import CopyStakeAutoclickerPromptsModal from '@/views/CopyStake/CopyStakeAiStreamer/AiStreamers/CopyStakeAutoclickerPromptsModal.vue';

import { PropType } from 'vue';
import {
  EStreamerType,
  EStreamingType,
  IStreamerListResponse,
  TAiStreamerVoiceRecord,
  TAiStreamerAvatarRecord,
  TAiStreamerGameData,
  TAiStreamerScriptRecord,
  TAiStreamerTemplate,
  TCopyStakeSettingsBetVolumesResponse,
  TCopyStakeSettingsAiStreamerMaxBetVolumeResponse,
  TStreamer,
  TWebAiStreamerPayload,
  EAiStreamerAvatarService,
  ValidationRules
} from '@/api/schema';
import * as vr from '@/helpers/validation';
import {
  createWebAiStreamer,
  deleteWebAiStreamer,
  getStreamersList,
  validateStreamer
} from '@/api/CopyStake/Streamers';
import { AxiosError } from 'axios';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import { mapGetters, mapState } from 'vuex';
import { getBetVolumesConfiguration } from '@/api/CopyStake/Settings';
import {
  TAiStreamer,
  TAiStreamerPayload
} from '@/views/CopyStake/CopyStakeAiStreamer/types';
import {
  createAiStreamerConfig,
  deleteAiStreamerScript,
  getAiStreamerMaxBetVolume,
  getAiStreamerVoiceLanguages,
  getAiStreamerVoices,
  getAiStreamerVoicesAvatarServices,
  getAiStreamerAvatarsList,
  getAiStreamerGames,
  getAiStreamerScriptList,
  getAiStreamerTemplates,
  updateAiStreamerConfig
} from '@/api/CopyStake/AiStreamer';

import { textOverflowMiddle, truncateString } from '@/helpers/formatString';
import { getLangCode, LANGUAGES } from '@/helpers/langHelpers';
import { cloneDeep } from 'lodash';

const CopyStakeWebAiStreamerProfileEditDialog = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeAiStreamer/WebAiStreamerProfiles/CopyStakeWebAiStreamerProfileEditDialog.vue'
  );
const CopyStakeWebAiStreamerProfileForm = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeAiStreamer/WebAiStreamerProfiles/CopyStakeWebAiStreamerProfileForm.vue'
  );
const VStatus = (): Promise<any> => import('@/components/VStatus.vue');
const ConfirmationDialog = (): Promise<any> =>
  import('@/components/ConfirmationDialog.vue');

const DEFAULT_MIN_BALANCE_AMOUNT = 10000;
const DEFAULT_CURRENCY = 'USD';
const DEFAULT_ZONE = 'UTC';

export const NO_AVATAR_ID = 'NO_AVATAR';

const EStreamerRadioGroupKey = {
  EXISTING_STREAMER: 'EXISTING_STREAMER',
  NEW_STREAMER: 'NEW_STREAMER'
};

const STREAMER_TYPE_MAP = {
  [EStreamerType.PRIVATE]: {
    label: 'Private',
    type: 'system-success'
  },
  [EStreamerType.PUBLIC]: {
    label: 'Public',
    type: 'additional-finished'
  }
};

const defaultFormAiStreamerData = (): Partial<TAiStreamer> => {
  return {
    id: null,
    streamerId: '',
    supportedGameIds: null,
    minBalanceAmount: DEFAULT_MIN_BALANCE_AMOUNT,
    defaultBetAmount: null,
    currency: DEFAULT_CURRENCY,
    scenarioTemplateId: '',
    startNow: false,
    baseScriptId: '',
    zone: DEFAULT_ZONE,
    avatarId: NO_AVATAR_ID,
    voiceLanguage: '',
    voiceId: '',
    avatarService: EAiStreamerAvatarService.CELLO_TTS
  };
};

const defaultFormWebAiStreamerProfileData =
  (): Partial<TWebAiStreamerPayload> => {
    return {
      nickname: '',
      operatorUserId: '',
      accessCode: '',
      type: EStreamerType.PUBLIC,
      shortBio: '',
      login: '',
      password: '',
      language: '',
      streamingType: EStreamingType.WEB_AI
    };
  };

export default {
  name: 'CopyStakeAiStreamerEditModal',
  components: {
    CopyStakeAutoclickerPromptsModal,
    CopyStakeWebAiStreamerProfileEditDialog,
    CopyStakeWebAiStreamerProfileForm,
    ConfirmationDialog,
    BaseDialog,
    AudioPlayerBtn,
    VExtendedDataPicker,
    VStatus
  },
  props: {
    form: {
      type: Object as PropType<Partial<TAiStreamer>>,
      default: defaultFormAiStreamerData
    },
    value: {
      type: Boolean,
      default: (): boolean => false
    }
  },
  data(): any {
    return {
      dialogs: {
        webAiStreamerProfileCreateEdit: false,
        confirm: false,
        loading: false,
        data: undefined
      },

      EStreamerRadioGroupKey,
      STREAMER_TYPE_MAP,
      currentStep: 1,
      selectStreamerRadioGroup: EStreamerRadioGroupKey.EXISTING_STREAMER,

      formDataAiStreamer: defaultFormAiStreamerData(),
      isFormAiStreamerValid: true,
      currencyList: [DEFAULT_CURRENCY],
      liveMaxBetAmount: null,
      isBetAmountOutdated: false,
      scenarioList: [],
      promptsList: [],
      avatarsList: [],
      avatarServicesList: [],
      avatarLanguagesList: [],
      avatarVoicesList: [],
      supportedGames: [],
      isShowPromptsModal: false,
      promptEditData: null,
      serverError: {
        nickname: null,
        operatorUserId: null,
        accessCode: null,
        type: null,
        shortBio: null,
        language: null
      },

      formDataWebAiStreamerProfile: defaultFormWebAiStreamerProfileData(),
      webAiStreamersProfilesList: null,

      loading: {
        configuration: false,
        templates: false,
        supportedGames: false,
        prompts: false,
        avatars: false,
        avatarServices: false,
        avatarLanguages: false,
        avatarVoices: false,
        loadWebAiStreamersProfiles: false,
        processing: false,
        maxBetAmount: false
      }
    };
  },
  computed: {
    ...mapState('Operator', ['languages']),
    ...mapGetters('Onboarding', [
      'operatorId',
      'isUndergroundCasinoGamesIntegrationType'
    ]),

    operatorLanguages(): any {
      return LANGUAGES.filter((lang) => this.languages.includes(lang.value));
    },
    currentAvatarPreviewUrl(): string | null {
      return (
        this.avatarsList?.find(
          ({ avatarId }) => avatarId === this.formDataAiStreamer?.avatarId
        )?.imageUrl || require('@/assets/images/ai-streamer-avatar.png')
      );
    },
    currentVoicePreviewUrl(): string | null {
      return (
        this.avatarVoicesList?.find(
          (voice: TAiStreamerVoiceRecord) =>
            voice.voiceId === this.formDataAiStreamer?.voiceId
        )?.previewUrl || null
      );
    },

    isHideBaseModal(): boolean {
      return (
        this.isShowPromptsModal ||
        this.dialogs.webAiStreamerProfileCreateEdit ||
        this.dialogs.confirm
      );
    },
    isNewConfig(): boolean {
      return !this.formDataAiStreamer.id;
    },
    isLoading(): boolean {
      return Object.values(this.loading).some(Boolean);
    },

    formAiStreamerPayload(): TAiStreamerPayload {
      return {
        ...this.formDataAiStreamer,
        supportedGameIds: this.formDataAiStreamer.supportedGameIds
          ? [this.formDataAiStreamer.supportedGameIds]
          : []
      };
    },

    rules(): ValidationRules {
      return {
        avatarId: [(v: string) => vr.required(v, 'Avatar')],
        avatarService: [(v: string) => vr.required(v, 'Voice Provider')],
        avatarLanguage: [(v: string) => vr.required(v, 'Language')],
        avatarVoice: [(v: string) => vr.required(v, 'Voice')],
        supportedGameIds: [
          (v: any) =>
            v !== null && v !== undefined && v !== ''
              ? true
              : 'Game is required'
        ],
        minBalanceAmount: [
          (v: string) => vr.required(v, 'Min Balance Amount'),
          vr.positiveNumber
        ],
        defaultBetAmount: [
          (v: string | null) => v === null || vr.positiveNumber(v),
          () =>
            !this.isBetAmountOutdated ||
            'Value is outdated. Click the reload icon, then save.'
        ],
        prompts: [(v: string) => vr.required(v, 'AI Streamer Script')],
        scenario: [(v: string) => vr.required(v, 'AI Avatar behaviour')],
        streamerId:
          this.selectStreamerRadioGroup ===
          EStreamerRadioGroupKey.EXISTING_STREAMER
            ? [(v: string) => vr.required(v, 'Streamer')]
            : []
      };
    }
  },
  watch: {
    async value(open: boolean): Promise<void> {
      await this.resetAiStreamerForm();
      await this.resetWebAiStreamerProfileForm();
      this.currentStep = 1;
      this.selectStreamerRadioGroup =
        EStreamerRadioGroupKey.EXISTING_STREAMER;

      if (!open) {
        return;
      }

      this.formDataAiStreamer = {
        ...this.form
      };

      if (!this.isNewConfig) {
        this.formDataAiStreamer.avatarService = this.form.avatarService
          ? this.form.avatarService
          : EAiStreamerAvatarService.ELEVEN_LABS;
      }

      if (!this.scenarioList.length) {
        this.getTemplates();
      }

      if (this.currencyList.length <= 1) {
        this.getConfiguration();
      }

      this.initMaxBetAmount();

      if (!this.avatarServicesList.length) {
        this.getAvatarServices();
      }

      if (this.formDataAiStreamer.avatarService) {
        this.getAvatarLanguages();
      }

      if (
        this.formDataAiStreamer.avatarService &&
        this.formDataAiStreamer.voiceLanguage
      ) {
        this.getAiStreamerAvatarVoices();
      }

      if (this.avatarsList.length <= 1) {
        this.getAvatars();
      } else {
        this.setPredefinedAvatar();
      }

      if (!this.webAiStreamersProfilesList) {
        this.fetchWebAiStreamerProfilesData();
      }

      if (!this.supportedGames.length) {
        await this.getSupportedGames();
      }

      if (this.form.supportedGameIds && this.form.supportedGameIds.length) {
        const availableIds = new Set(
          (this.supportedGames || []).map((g: TAiStreamerGameData) => g.id)
        );

        const filteredIds = this.form.supportedGameIds.filter((id: number) =>
          availableIds.has(id)
        );

        this.formDataAiStreamer.supportedGameIds =
          filteredIds.length > 0 ? filteredIds[0] : null;
      }
    },
    async 'formDataAiStreamer.voiceLanguage'(): Promise<void> {
      await this.getPrompts();

      this.setDefaultPrompt();
    }
  },
  methods: {
    truncateString,
    textOverflowMiddle,

    async getConfiguration(): Promise<void> {
      if (!this.operatorId) {
        return;
      }

      this.loading.configuration = true;

      getBetVolumesConfiguration()
        .then((data: TCopyStakeSettingsBetVolumesResponse) => {
          if (data) {
            this.currencyList = Object.keys(data);
          }
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.loading.configuration = false;
        });
    },

    async fetchLiveMaxBetAmount(currency: string): Promise<number | null> {
      if (!currency) return null;

      this.loading.maxBetAmount = true;

      return getAiStreamerMaxBetVolume(currency)
        .then(
          (data: TCopyStakeSettingsAiStreamerMaxBetVolumeResponse) =>
            data?.[currency] ?? null
        )
        .catch((err: AxiosError): null => {
          errorToastMessage(err);
          return null;
        })
        .finally(() => {
          this.loading.maxBetAmount = false;
        });
    },

    async initMaxBetAmount(): Promise<void> {
      const currency = this.formDataAiStreamer.currency;
      const live = await this.fetchLiveMaxBetAmount(currency);

      this.liveMaxBetAmount = live;

      if (this.isNewConfig) {
        this.formDataAiStreamer.defaultBetAmount = live;
        this.isBetAmountOutdated = false;
      } else {
        this.isBetAmountOutdated = !this.isSameBetAmount(
          live,
          this.formDataAiStreamer.defaultBetAmount
        );
      }

      this.$nextTick(() => {
        (this.$refs.betAmountField as any)?.validate(true);
      });
    },

    isSameBetAmount(
      a: number | string | null,
      b: number | string | null
    ): boolean {
      if (a === null || b === null) return a === b;

      return Number(a) === Number(b);
    },

    async onCurrencyChange(): Promise<void> {
      const currency = this.formDataAiStreamer.currency;
      const live = await this.fetchLiveMaxBetAmount(currency);

      this.liveMaxBetAmount = live;
      this.formDataAiStreamer.defaultBetAmount = live;
      this.isBetAmountOutdated = false;
    },

    async reloadMaxBetAmount(): Promise<void> {
      const currency = this.formDataAiStreamer.currency;
      const live = await this.fetchLiveMaxBetAmount(currency);

      this.liveMaxBetAmount = live;
      this.formDataAiStreamer.defaultBetAmount = live;
      this.isBetAmountOutdated = false;
    },
    async getSupportedGames(): Promise<void> {
      this.loading.supportedGames = true;

      await getAiStreamerGames()
        .then((data) => {
          this.supportedGames = data;
        })
        .catch((error: AxiosError) => {
          errorToastMessage(error);
          this.supportedGames = [];
        })
        .finally(() => {
          this.loading.supportedGames = false;
        });
    },
    async getTemplates(): Promise<void> {
      this.loading.templates = true;

      getAiStreamerTemplates()
        .then((data: TAiStreamerTemplate[]): void => {
          this.scenarioList = data;
        })
        .catch(() => {
          this.scenarioList = [];
        })
        .finally(() => {
          this.loading.templates = false;
        });
    },
    async getPrompts(id: number): Promise<void> {
      if (!this.formDataAiStreamer.voiceLanguage) return;

      this.loading.prompts = true;

      return getAiStreamerScriptList(this.formDataAiStreamer.voiceLanguage)
        .then((data: TAiStreamerScriptRecord[]): void => {
          this.promptsList = data;

          if (id) this.formDataAiStreamer.baseScriptId = id;
        })
        .catch(() => {
          this.promptsList = [];
        })
        .finally(() => {
          this.loading.prompts = false;
        });
    },
    async getAvatars(): Promise<void> {
      this.loading.avatars = true;

      getAiStreamerAvatarsList()
        .then((data: TAiStreamerAvatarRecord[]): void => {
          this.avatarsList = data.sort((a, b) =>
            a.avatarName.localeCompare(b.avatarName)
          );

          this.setPredefinedAvatar();
        })
        .catch(() => {
          this.avatarsList = [];
        })
        .finally(() => {
          this.loading.avatars = false;
        });
    },
    async getAvatarServices(): Promise<void> {
      this.loading.avatarServices = true;

      getAiStreamerVoicesAvatarServices()
        .then((data: EAiStreamerAvatarService[]): void => {
          this.avatarServicesList = data;
        })
        .catch(() => {
          this.avatarServicesList = [];
        })
        .finally(() => {
          this.loading.avatarServices = false;
        });
    },
    async getAvatarLanguages(): Promise<void> {
      if (!this.formDataAiStreamer.avatarService) {
        this.avatarLanguagesList = [];
        this.avatarVoicesList = [];

        return;
      }

      this.loading.avatarLanguages = true;

      getAiStreamerVoiceLanguages(this.formDataAiStreamer.avatarService)
        .then((data: string[]): void => {
          const voiceLanguages = data.map((language: string) => ({
            language: language,
            languageCode: getLangCode(language)
          }));

          this.avatarLanguagesList = voiceLanguages.sort((a, b) => {
            if (a.language === 'English') return -1;
            if (b.language === 'English') return 1;
            return a.language.localeCompare(b.language);
          });
        })
        .catch(() => {
          this.avatarLanguagesList = [];
        })
        .finally(() => {
          this.loading.avatarLanguages = false;
        });
    },
    async getAiStreamerAvatarVoices(): Promise<void> {
      if (
        !this.formDataAiStreamer.avatarService ||
        !this.formDataAiStreamer.voiceLanguage
      ) {
        this.avatarVoicesList = [];

        return;
      }

      this.loading.avatarVoices = true;

      getAiStreamerVoices(
        this.formDataAiStreamer.avatarService,
        this.formDataAiStreamer.voiceLanguage
      )
        .then((data: TAiStreamerVoiceRecord[]): void => {
          this.avatarVoicesList = data.map(
            (voice: TAiStreamerVoiceRecord) => ({
              ...voice,
              voicePreviewUrl: voice.previewUrl || null,
              languageCode: getLangCode(voice.language)
            })
          );
        })
        .catch(() => {
          this.avatarVoicesList = [];
        })
        .finally(() => {
          this.loading.avatarVoices = false;
        });
    },
    async fetchWebAiStreamerProfilesData(): Promise<void> {
      if (!this.operatorId) return;

      this.loading.loadWebAiStreamersProfiles = true;

      getStreamersList({
        size: 1000,
        page: 0,
        operatorId: this.operatorId,
        streamingType: EStreamingType.WEB_AI
      })
        .then((data: IStreamerListResponse) => {
          this.webAiStreamersProfilesList = data.content
            .filter(({ nickname }) => !!nickname)
            .map((item: TStreamer) => ({
              ...item,
              text: item.nickname,
              value: item.id,
              type: item.type
            }));
        })
        .catch((error: AxiosError): void => {
          errorToastMessage(error);
        })
        .finally(() => {
          this.loading.loadWebAiStreamersProfiles = false;
        });
    },

    setPredefinedAvatar(): void {
      if (
        this.isNewConfig &&
        this.avatarsList.length &&
        !this.formDataAiStreamer.avatarId
      ) {
        this.formDataAiStreamer.avatarId = NO_AVATAR_ID;
      }
    },
    setDefaultPrompt(): void {
      if (
        !this.promptsList?.length ||
        !this.formDataAiStreamer.voiceLanguage
      ) {
        this.formDataAiStreamer.baseScriptId = null;

        return;
      }

      const hasFormBaseId = !!this.form?.baseScriptId;
      if (hasFormBaseId) {
        const found = this.promptsList.find(
          (script: TAiStreamerScriptRecord) =>
            script.id === this.form.baseScriptId
        );
        if (found) {
          this.formDataAiStreamer.baseScriptId = found.id;
          this.$nextTick(() => {
            this.$refs.promptsInput?.validate();
          });
          return;
        }
      }

      const systemPrompt = this.promptsList.find(
        (script: TAiStreamerScriptRecord) => script.isSystem
      );
      this.formDataAiStreamer.baseScriptId = systemPrompt
        ? systemPrompt.id
        : null;
      this.$nextTick(() => {
        this.$refs.promptsInput?.validate();
      });
    },
    async changeAvatarServiceHandler(): Promise<void> {
      this.formDataAiStreamer.voiceLanguage = '';
      this.formDataAiStreamer.voiceId = '';

      await this.getAvatarLanguages();
      this.avatarVoicesList = [];

      await this.$refs.aiStreamerFormStep1?.resetValidation();
    },
    async changeVoiceLanguageHandler(): Promise<void> {
      this.formDataAiStreamer.voiceId = '';

      await this.getAiStreamerAvatarVoices();

      await this.$refs.aiStreamerFormStep1?.resetValidation();
    },
    addNewPromptsHandler(): void {
      this.promptEditData = null;
      this.isShowPromptsModal = true;
    },
    copyPromptsHandler(item: TAiStreamerScriptRecord): void {
      this.$refs.promptsInput.isMenuActive = false;

      this.promptEditData = {
        ...cloneDeep(item),
        id: null,
        name: item.name + ' - Copy'
      };
      this.isShowPromptsModal = true;
    },
    editPromptsHandler(item: TAiStreamerScriptRecord): void {
      this.$refs.promptsInput.isMenuActive = false;

      this.promptEditData = cloneDeep(item);
      this.isShowPromptsModal = true;
    },
    deletePromptsHandler(item: TAiStreamerScriptRecord): void {
      this.$refs.promptsInput.isMenuActive = false;
      this.dialogs.confirm = true;

      this.dialogs.data = {
        disclaimer: `
            <p>
              Are you sure you want to delete the <strong>${item.name}</strong> script?
            </p>`,
        header: 'Delete Script',
        okText: 'Delete',
        maxWidth: '640',
        handler: async () => {
          try {
            this.dialogs.loading = true;

            if (this.formDataAiStreamer.baseScriptId === item.id) {
              this.formDataAiStreamer.baseScriptId = null;
            }
            await deleteAiStreamerScript(item.id);
            this.getPrompts();
            this.$toast.success(
              `"${item.name}" script was successfully deleted`
            );

            this.closeDialog('confirm');
          } catch (error) {
            errorToastMessage(error);
          } finally {
            this.dialogs.loading = false;
          }
        }
      };
    },
    async resetAiStreamerForm(): Promise<void> {
      await this.$refs.aiStreamerFormStep1?.reset();

      this.formDataAiStreamer = {
        ...this.formDataAiStreamer,
        ...defaultFormAiStreamerData()
      };
    },
    async resetWebAiStreamerProfileForm(): Promise<void> {
      await this.$refs.webAiStreamerProfileForm?.reset();
      await this.$refs.aiStreamerFormStep2?.reset();

      this.resetServerErrors();

      this.formDataWebAiStreamerProfile = {
        ...defaultFormAiStreamerData()
      };
    },
    resetServerErrors(): void {
      this.serverError = {
        nickname: null,
        accessCode: null,
        operatorUserId: null,
        type: null,
        shortBio: null,
        language: null
      };
    },
    parseServerErrors(error: AxiosError): void {
      if (error instanceof AxiosError) {
        const errorMessage = error.response?.data?.message;
        if (!errorMessage) return;

        if (
          errorMessage.includes('Streamer with access code') ||
          errorMessage.includes('Streamer with accessCode')
        ) {
          this.serverError.accessCode = errorMessage;
        }

        if (errorMessage.includes('Streamer with nickname')) {
          this.serverError.nickname = errorMessage;
        }

        if (errorMessage.includes('Streamer with user')) {
          this.serverError.operatorUserId = errorMessage;
        }

        if (errorMessage.includes('User by operatorUserId')) {
          this.serverError.operatorUserId = errorMessage;
        }

        if (errorMessage.includes('shortBio')) {
          this.serverError.shortBio = errorMessage;
        }
      }
    },

    async handleClickNextBtn(): Promise<void> {
      await this.$refs.aiStreamerFormStep1.validate();

      if (!this.isFormAiStreamerValid) return;

      this.currentStep += 1;
    },
    handlerOnCreateEditWebAiStreamerProfile(
      webAiStreamerProfile?: TStreamer
    ): void {
      if (webAiStreamerProfile) {
        this.dialogs.data = webAiStreamerProfile;
      }

      this.dialogs.webAiStreamerProfileCreateEdit = true;
    },
    async handleSubmitCreateEditWebAiStreamerProfileDialog(): Promise<void> {
      await this.fetchWebAiStreamerProfilesData();
    },
    handlerOnDeleteWebAiStreamerProfile(
      webAiStreamerProfile: TStreamer
    ): void {
      this.dialogs.confirm = true;
      this.dialogs.data = {
        disclaimer: `
            <p>
              Are you sure you want to delete <strong>${webAiStreamerProfile.nickname}</strong> Streamer Profile?
            </p>
            <p class="text--disabled">You will not be able to recover it.</p>`,
        icon: 'mdi-alert-octagon',
        header: 'Delete Streamer Profile',
        okText: 'Delete',
        maxWidth: '640',
        handler: async () => {
          try {
            this.dialogs.loading = true;

            await deleteWebAiStreamer(webAiStreamerProfile.id);
            this.fetchWebAiStreamerProfilesData();
            this.$toast.success(
              `Streamer "${webAiStreamerProfile.nickname}" profile was successfully deleted`
            );

            this.closeDialog('confirm');
          } catch (error) {
            errorToastMessage(error);
          } finally {
            this.dialogs.loading = false;
          }
        }
      };
    },
    async handleSubmit(): Promise<void> {
      this.isFormAiStreamerValid =
        await this.$refs.aiStreamerFormStep2.validate();

      if (!this.isFormAiStreamerValid || this.loading.processing) return;

      if (
        this.selectStreamerRadioGroup === EStreamerRadioGroupKey.NEW_STREAMER
      ) {
        try {
          this.resetServerErrors();
          const isValid = await (
            this.$refs.webAiStreamerProfileForm as any
          ).validate();

          if (!isValid || this.loading.processing) return;
          this.loading.processing = true;

          const payloadCreateWebAiStreamerProfile = {
            ...this.formDataWebAiStreamerProfile,
            accessCode:
              (this.formDataWebAiStreamerProfile.accessCode &&
                this.formDataWebAiStreamerProfile.accessCode.toUpperCase()) ||
              null
          };

          if (this.isUndergroundCasinoGamesIntegrationType) {
            payloadCreateWebAiStreamerProfile.login = null;
            payloadCreateWebAiStreamerProfile.password = null;
          }

          await validateStreamer({
            ...payloadCreateWebAiStreamerProfile,
            streamingType: EStreamingType.WEB_AI
          });

          const newWebAiStreamerProfile = await createWebAiStreamer(
            payloadCreateWebAiStreamerProfile
          );

          this.formDataAiStreamer.streamerId = newWebAiStreamerProfile.id;
        } catch (error) {
          this.parseServerErrors(error);
          errorToastMessage(error);
          return;
        } finally {
          this.loading.processing = false;
        }
      }
      this.loading.processing = true;

      if (this.isNewConfig) {
        createAiStreamerConfig(this.formAiStreamerPayload)
          .then(() => {
            this.$toast.success('AI Streamer Config created');
            this.$emit('update');
            this.closeModal();
          })
          .catch(errorToastMessage)
          .finally(() => {
            this.loading.processing = false;
          });
      } else {
        updateAiStreamerConfig(this.formAiStreamerPayload)
          .then(() => {
            this.$toast.success('AI Streamer Config updated');
            this.$emit('update');
            this.closeModal();
          })
          .catch(errorToastMessage)
          .finally(() => {
            this.loading.processing = false;
          });
      }
    },

    closeDialog(type: string, resetData: boolean = true): void {
      this.dialogs[type] = false;

      if (resetData) {
        this.$nextTick(() => {
          this.dialogs.data = {};
        });
      }
    },
    closeModal(): void {
      this.$emit('input', false);
    }
  }
};
